import React, { Component } from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import detector from "detector";
import screenfull from "screenfull";

import { ICommonTaskProps } from "../../../common/types";
import { isMobile } from "../../../common/parameters";
import Seo from "../../../common/helpers/seo";

import { setItem, hasItem, getItem } from "../../cookie";
import routing from "../../routing";

import Experience from "../../components/Experience";
import Modal from "../../components/Modal";
import Form, { Title, InputText, Submit, Label, Cancel } from "../../components/Form";
import NotFound from "../../components/NotFound";
import Loader, { LoaderWrapper } from "../../components/Loader";
import TaskDescriptionModal from "../../components/TaskDescriptionModal";

import TaskSwitch from "../../components/TaskSwitch";

import Menu from "./HomeworkMenu";
import { getStore, setStore } from "./store";
import { StyledLoader, PlayWrapper, ChangeOrientation, SuccessCompletion, Description, Privacy } from "./styles";
import messages from "./messages";
import { IProps, ITaskResult, IState, IHistory } from "./interfaces";

class HomeworkPlay extends Component<IProps, IState> {
    state: IState = {
        name: "",
        isNextEnabled: false,
        orientationForceClosed: false,
        complete: {
            isFetching: false,
            success: false,
            isModalOpen: false,
        },
        canGiveUp: false,
        giveUpConfirm: false,
        isExperience: false,
        experienceCompletedExerices: [],
        isDescriptionVisible: !!process.env.WEBPACK,
        taskIndex: null,
        modalNotFound: false,
        paging: false,
        isLow: false,
        nameModal: false,
        changeOrientation: false,
        isFullscreen: false,
        validationName: null,
    };
    currentTaskPlayed = 0;
    currentTaskFailed = 0;
    results: ITaskResult[] = [];
    history: IHistory[] = [];
    startTime = new Date().getTime();
    id?: string;
    savedStates: any[] = [];
    giveUpTimer?: ReturnType<typeof setTimeout>;
    saveState?: () => any;
    restoreState?: (state: any) => void;
    showSolution?: () => void;
    handleReset?: () => void;
    handleExperienceGiveUp?: () => void
    componentDidMount() {
        let isLow = true;
        if (hasItem("isLow")) isLow = getItem("isLow") === "1";
        else setItem("isLow", "1", 60 * 60 * 24 * 365 * 3, "/");
        this.setState({
            taskIndex: this.state.isExperience ? null : 0,
            isLow,
        });
        if (!process.env.WEBPACK) {
            return;
        }
        if (detector.os.name !== "ios") {
            document.body.style.overflowY = "hidden";
        }
        this.getPlan();
        if (isMobile) {
            this.checkOrientation();
            window.addEventListener("orientationchange", this.checkOrientation);
            if (screenfull && screenfull.enabled) {
                setTimeout(() => {
                    if (screenfull) {
                        this.setState({ isFullscreen: screenfull.isFullscreen });
                        // screenfull.on("change", this.changeFullScreen);
                    }
                }, 200);
            }
        }
    }

    checkOrientation = () => {
        let landscape = false;
        if (detector.os.name === "ios") {
            if (Math.abs(Number(window.orientation)) === 90) {
                landscape = true;
            } else {
                landscape = false;
            }
        } else {
            if (!window.screen.orientation) {
                this.setState({ changeOrientation: false });
                return;
            } else {
                landscape = window.screen.orientation.type.indexOf("landscape") !== -1;
            }
        }
        setTimeout(() => {
            if (!landscape) {
                this.setState({ changeOrientation: true });
            } else {
                this.setState({ changeOrientation: false });
            }
        });
    };

    getPlan = () => {
        const { changeStudentColors, changeStudentPitchNotation, changeStudentRhythmSyllableTypes, changeStudentSolfaAudio, changeStudentReversedToneset, changeStudentSolfaShort, changeStudentSolfaKam } = this.props;
        this.id = this.props.match.params.id;
        if (!hasItem("homeworkPlanId") || getItem("homeworkPlanId") !== this.id) {
            this.props.history.push(`/${routing.homework}`);
            return;
        }
        const { get, user, intl: { locale } } = this.props;
        this.savedStates = [];
        get(`plan-for-homework?id=${this.id}`, res => {
            const { data } = res;
            if (!data.found) {
                this.setState({ modalNotFound: true });
                return;
            } else {
                changeStudentColors(data.colors);
                changeStudentPitchNotation(data.pitchNotation);
                changeStudentRhythmSyllableTypes(data.rhythmSyllableType);
                changeStudentSolfaAudio(data.solfaAudio);
                changeStudentReversedToneset(data.reversedToneset);
                changeStudentSolfaShort(data.solfaShort);
                changeStudentSolfaKam(data.solfaKam);
                const isExperience = data.isExperience && data.plan.experience.enabled;
                if (isExperience) window.homeworkAsExperience = true;
                let taskIndex = isExperience ? null : 0;
                const loadedState = getStore()!;
                let name = "";
                let nameModal = true;
                let isNextEnabled = isExperience ? false : (data.plan.tasks[taskIndex!].type === "embed" || data.plan.tasks[taskIndex!].type === "subScore");
                let experienceCompletedExerices: (number | null)[] = [];
                if (loadedState.id === this.id) {
                    this.results = loadedState.results;
                    name = loadedState.name;
                    taskIndex = isExperience ? null : this.results.length;
                    nameModal = false;
                    if (isExperience) {
                        experienceCompletedExerices = this.results.map((r, i) => {
                            if (r !== null) {
                                return i;
                            }
                            return null;
                        }).filter(r => r !== null)
                    }
                } else if (user.loggedIn && user.isStudent) {
                    if (!data.description) {
                        nameModal = false;
                    }
                    if (locale === "hu") {
                        name = `${user.last_name} ${user.first_name}`;
                    } else {
                        name = `${user.first_name} ${user.last_name}`;
                    }
                }
                this.startGiveUpTime();
                this.setState({
                    taskIndex,
                    name,
                    plan: data.plan,
                    nameModal,
                    description: data.description,
                    isNextEnabled,
                    experienceCompletedExerices,
                    isExperience,
                });
            }
        });
    };

    componentWillUnmount() {
        document.body.style.overflowY = "";
        clearTimeout(this.giveUpTimer);
        window.homeworkAsExperience = false;
    }

    isDone = false;

    restartHomework = () => {
        setStore({});
        window.location.reload();
    }

    setTaskIndex = (screenIndex: null | number, difficulty: "easy" | "hard" | null) => {
        const { plan } = this.state;
        const position: number | number[] | null = plan!.experience.positions[screenIndex!];
        let taskId: number | null = null;
        if (Array.isArray(position)) {
            taskId = position[difficulty === "easy" ? 0 : 1];
        } else {
            taskId = position;
        }
        let taskIndex: number | null = plan!.tasks.findIndex(task => task.id === taskId);
        if (taskIndex === -1) taskIndex = null;
        this.goToPage(taskIndex);
    };

    goToPage = (taskIndex: number | null) => {
        const { plan, isExperience } = this.state;
        if (taskIndex === plan!.tasks.length) {
            if (!this.isDone) {
                this.done();
            }
            this.isDone = true;
            return;
        }
        if (taskIndex === null && isExperience) {
            let isCompleted = true;
            plan!.experience.positions.forEach(position => {
                if (Array.isArray(position)) {
                    const ti1 = plan!.tasks.findIndex(task => task.id === position[0]);
                    const ti2 = plan!.tasks.findIndex(task => task.id === position[1]);
                    if ((this.results[ti1] === null || this.results[ti1] === undefined) &&
                        (this.results[ti2] === null || this.results[ti2] === undefined)) {
                        isCompleted = false;
                    }
                } else if (typeof position === "number") {
                    const ti = plan!.tasks.findIndex(task => task.id === position);
                    if (this.results[ti] === null || this.results[ti] === undefined) {
                        isCompleted = false;
                    }
                }
            })
            if (isCompleted) {
                setTimeout(() => {
                    if (!this.isDone) {
                        this.isDone = true;
                        this.done();
                    } 
                }, 3500);
            }
        }
        if (this.saveState) {
            this.savedStates[this.state.taskIndex!] = this.saveState();
        }
        setStore({
            results: this.results,
            id: this.id,
            name: this.state.name,
        });
        this.saveState = undefined;
        this.showSolution = undefined;
        const lastHistory = this.history[this.state.taskIndex!];
        if (this.state.taskIndex) {
            this.history[this.state.taskIndex] = {
                currentTaskPlayed: this.currentTaskPlayed,
                currentTaskFailed: this.currentTaskFailed,
                totalTime: (lastHistory ? lastHistory.totalTime : 0) + ((new Date().getTime() - this.startTime) / 1000),
            };
        }
        this.startTime = new Date().getTime();
        this.currentTaskPlayed = 0;
        this.currentTaskFailed = 0;
        if (isExperience && this.history[taskIndex!]) {
            this.currentTaskPlayed = this.history[taskIndex!].currentTaskPlayed;
            this.currentTaskFailed = this.history[taskIndex!].currentTaskFailed;
        }
        if (isExperience && taskIndex === null) {
            this.setState({ taskIndex, isDescriptionVisible: false })
            return;
        }
        this.startGiveUpTime();
        this.setState({ paging: true, isNextEnabled: false, taskIndex, isDescriptionVisible: false }, () => {
            this.setState({ paging: false }, () => {
                if (plan!.tasks[taskIndex!].type === "embed" || plan!.tasks[taskIndex!].type === "subScore") {
                    this.setState({ isNextEnabled: true });
                }
                if (this.restoreState && this.savedStates[taskIndex!]) {
                    setTimeout(() => {
                        this.restoreState!(this.savedStates[taskIndex!]);
                    });
                }
                setTimeout(() => {
                    this.setState({ isDescriptionVisible: true });
                }, isExperience ? 2500 : 500);
            });
        });
    };
    restart = () => {
        this.handleReset!();
    };
    switchIsLow = () => {
        let { isLow } = this.state;
        isLow = !isLow;
        this.setState({ isLow });
        setItem("isLow", isLow ? "1" : "0", 60 * 60 * 24 * 365 * 3, "/");
    };
    isLastSubmitableTask = (taskIndex: number) => {
        const { tasks } = this.state.plan!;
        for (let i = taskIndex + 1; i < tasks.length; i++) {
            if (tasks[i].type !== "embed" && tasks[i].type !== "subScore") return false;
        }
        return true;
    };
    completed = (gaveUp = false, notSupported = false) => {
        const { taskIndex, isExperience } = this.state;
        const lastHistory = this.history[this.state.taskIndex!];
        const time = +(((new Date().getTime() - this.startTime) / 1000) + (lastHistory ? lastHistory.totalTime : 0)).toFixed(0);
        this.results[taskIndex!] = {
            time,
            play: this.currentTaskPlayed,
            fail: this.currentTaskFailed,
            gaveUp: notSupported || gaveUp,
        };
        if (this.isLastSubmitableTask(taskIndex!) && !isExperience) {
            this.submitResults();
        }
        clearTimeout(this.giveUpTimer);
        if (gaveUp) {
            this.goToPage(isExperience ? null : taskIndex! + 1);
        } else {
            this.setState({ isNextEnabled: true });
        }
    };
    goToNextPage = () => {
        const { taskIndex } = this.state;
        this.goToPage(taskIndex! + 1);
    };
    submitResults = () => {
        if (this.state.complete.isFetching) return;
        this.setState(
            {
                complete: {
                    ...this.state.complete,
                    isFetching: true,
                },
            },
            () => {
                this.props.post(
                    "homework-done",
                    { result: this.results, id: this.id, name: this.state.name },
                    ({ data }: { data: string }) => {
                        setStore({});
                        this.setState(
                            {
                                complete: {
                                    ...this.state.complete,
                                    success: true,
                                    isFetching: false,
                                    homeworkResultId: data,
                                },
                            },
                            () => {
                                if (this.state.complete.isModalOpen) {
                                    this.goToCompletedPage();
                                }
                            }
                        );
                    },
                    () => {
                        this.setState({
                            complete: {
                                ...this.state.complete,
                                isFetching: false,
                            },
                        });
                    }
                );
            }
        );
    };
    done = () => {
        this.setState(
            {
                complete: {
                    ...this.state.complete,
                    isModalOpen: true,
                },
            },
            () => {
                if (!this.state.complete.success) {
                    this.submitResults();
                } else {
                    setStore({});
                    if (!this.state.complete.isFetching) {
                        this.goToCompletedPage();
                    }
                }
            }
        );
    };
    handleGiveUp = () => {
        this.setState({ giveUpConfirm: true });
    };
    handleGiveUpConfirmed = () => {
        const { isExperience } = this.state;
        this.setState({ giveUpConfirm: false });
        if (isExperience) {
            this.showSolution!();
            this.handleExperienceGiveUp!();
        }
        setTimeout(() => {
            this.completed(true);
        });
    };

    handleGiveUpConfirmeCancel = () => {
        this.setState({ giveUpConfirm: false });
    };

    goToCompletedPage = () => {
        const { user } = this.props;
        if (user.isStudent) {
            this.props.history.push(`/${routing.homeworkStudentResults}/${this.id}`);
        } else {
            this.props.history.push(`/${routing.homeworkCompleted}/${this.state.complete.homeworkResultId}`);
        }
    };
    nameChange = (e: React.FormEvent<HTMLInputElement> ) => {
        if (e.currentTarget.value.length > 24) return;
        this.setState({ name: e.currentTarget.value, validationName: null });
    };
    setName = () => {
        const { name } = this.state;
        if (name.length === 0) return this.setState({ validationName: "required" });
        if (name.length < 2) return this.setState({ validationName: "tooShortJoinName" });
        this.setState({ nameModal: false });
        this.startTime = new Date().getTime();
        this.startGiveUpTime();
    };
    startGiveUpTime = () => {
        this.setState({
            canGiveUp: false,
        });
        clearTimeout(this.giveUpTimer);
        this.giveUpTimer = setTimeout(() => {
            this.setState({
                canGiveUp: true,
            });
        }, 60 * 1000);
    };
    forceClose = () => {
        this.setState({
            orientationForceClosed: true,
        });
    };
    handlePlayCount = () => {
        this.currentTaskPlayed++;
    };
    handleFailCount = () => {
        this.currentTaskFailed++;
    };
    handleGoToResultsOnExperience = () => {
        if (!this.isDone) {
            this.isDone = true;
            this.done();
        }
    }
    render() {
        const {
            modalNotFound,
            paging,
            taskIndex,
            isLow,
            plan,
            nameModal,
            changeOrientation,
            isFullscreen,
            validationName,
            name,
            isNextEnabled,
            orientationForceClosed,
            description,
            complete,
            canGiveUp,
            giveUpConfirm,
            isExperience,
            experienceCompletedExerices,
            isDescriptionVisible,
        } = this.state;
        const {
            intl: { formatMessage },
            user,
        } = this.props;
        if (modalNotFound) {
            return (
                <PlayWrapper>
                    <Seo title={formatMessage(messages.notFound)} noindex />
                    <NotFound close={() => this.props.history.goBack()} />
                </PlayWrapper>
            );
        }
        if (!plan || (taskIndex === null && !isExperience) || plan.loading)
            return (
                <StyledLoader>
                    <LoaderWrapper>
                        <Loader />
                    </LoaderWrapper>
                </StyledLoader>
            );
        const task = plan.tasks[taskIndex!];
        if (!task && !isExperience) {
            return (
                <div>
                    <FormattedMessage {...messages.loading} />
                </div>
            );
        }
        const showFullScreenModal = !nameModal &&
            !changeOrientation &&
            !isFullscreen &&
            screenfull &&
            screenfull.enabled &&
            isMobile &&
            !orientationForceClosed;
        return (
            <PlayWrapper>
                <Seo title={plan.name as unknown as string} type={"article"} noindex nofollow />
                <Menu
                    plan={plan}
                    taskIndex={taskIndex}
                    goToPage={this.goToPage}
                    restart={this.restart}
                    switchIsLow={this.switchIsLow}
                    isNextEnabled={isNextEnabled}
                    canGiveUp={canGiveUp}
                    handleGiveUp={this.handleGiveUp}
                    isFetching={complete.isFetching}
                    restartHomework={this.restartHomework}
                    isExperience={isExperience}
                    results={this.results}
                />
                {!paging && !isExperience && (() => {
                    const Task = TaskSwitch(task.type) as (props: ICommonTaskProps) => JSX.Element;
                    return (
                        <Task
                            task={task}
                            playPlan
                            setReset={f => (this.handleReset = f)}
                            saveState={saveState => (this.saveState = saveState)}
                            restoreState={restoreState => (this.restoreState = restoreState)}
                            showSolution={showSolution => (this.showSolution = showSolution)}
                            isLow={isLow}
                            plan={plan}
                            completed={(type, notSupported) => {
                                this.completed(false, notSupported);
                                this.props.taskCompleted({
                                    type,
                                    editor: false,
                                    planId: plan._id,
                                    page: "homework",
                                    isExperience,
                                });
                            }}
                            handlePlayCount={this.handlePlayCount}
                            handleFailCount={this.handleFailCount}
                            handleHomeworkNext={this.goToNextPage}
                        />
                    )
                })()}
                {isExperience && plan.experience?.enabled && (
                    <Experience
                        plan={plan}
                        setReset={f => (this.handleReset = f)}
                        saveState={saveState => (this.saveState = saveState)}
                        restoreState={restoreState => (this.restoreState = restoreState)}
                        showSolution={showSolution => (this.showSolution = showSolution)}
                        setTaskIndex={this.setTaskIndex}
                        setGiveUp={(handleGiveUp) => (this.handleExperienceGiveUp = handleGiveUp)}
                        handlePlayCount={this.handlePlayCount}
                        handleFailCount={this.handleFailCount}
                        completed={(type: string) => {
                            this.completed(false, false);
                            this.props.taskCompleted({
                                type,
                                editor: false,
                                planId: plan._id,
                                page: "homework",
                                isExperience,
                            });
                        }}
                        experienceCompletedExerices={experienceCompletedExerices}
                        handleGoToResultsOnExperience={this.handleGoToResultsOnExperience}
                    />
                )}
                {nameModal && (
                    <Modal>
                        <Form>
                            <Title>{plan.name}</Title>
                            {description && (
                                <>
                                    <Label>
                                        <FormattedMessage {...messages.homeworkDescription} />
                                    </Label>
                                    <Description>{description}</Description>
                                </>
                            )}
                            {(!user.loggedIn || !user.isStudent) && (
                                <>
                                    <InputText
                                        validation={validationName}
                                        label={<FormattedMessage {...messages.name} />}
                                        value={name}
                                        onChange={this.nameChange}
                                        focusOnMount
                                    />
                                    <Privacy>
                                        <FormattedMessage {...messages.privacyNote} values={{
                                            privacyPolicy: <a className="link" target="_blank" href={`/${routing.privacy}`}>
                                                <FormattedMessage {...messages.privacy} />
                                            </a>
                                        }} />
                                    </Privacy>
                                </>
                            )}
                            <Submit onClick={this.setName}>
                                <FormattedMessage {...messages.submitName} />
                            </Submit>
                        </Form>
                    </Modal>
                )}
                {!nameModal && changeOrientation && (
                    <Modal>
                        <Form>
                            <ChangeOrientation>
                                <FormattedHTMLMessage {...messages.turnDevice} />
                            </ChangeOrientation>
                        </Form>
                    </Modal>
                )}
                {complete.isModalOpen && (
                    <Modal noBorderRadius>
                        <SuccessCompletion>
                            <Form>
                                {(complete.isFetching || complete.success) && (
                                    <LoaderWrapper>
                                        <Loader />
                                    </LoaderWrapper>
                                )}
                                {!complete.isFetching && !complete.success && (
                                    <button className="button" onClick={this.done}>
                                        <FormattedMessage {...messages.retry} />
                                    </button>
                                )}
                            </Form>
                        </SuccessCompletion>
                    </Modal>
                )}
                {showFullScreenModal && (
                    <Modal close={this.forceClose}>
                        <Form>
                            <ChangeOrientation>
                                <FormattedMessage {...messages.toFullScreen} />
                            </ChangeOrientation>
                            <Submit onClick={() => {
                                if (screenfull) {
                                    screenfull.request()
                                }
                            }}>
                                <FormattedMessage {...messages.fullScreenButton} />
                            </Submit>
                        </Form>
                    </Modal>
                )}
                {giveUpConfirm && (
                    <Modal close={this.handleGiveUpConfirmeCancel}>
                        <Form>
                            <Title>
                                <FormattedMessage {...messages.confirmGiveUpTitle} />
                            </Title>
                            <Submit onClick={this.handleGiveUpConfirmed}>
                                <FormattedMessage {...messages.giveUp} />
                            </Submit>
                            <Cancel onClick={this.handleGiveUpConfirmeCancel}>
                                <FormattedMessage {...messages.cancel} />
                            </Cancel>
                        </Form>
                    </Modal>
                )}
                {!nameModal && !changeOrientation && !showFullScreenModal && task && isDescriptionVisible && (
                    <TaskDescriptionModal task={task}/>
                )}
            </PlayWrapper>
        );
    }
}

export default HomeworkPlay;
